import type { RouteDefinition } from "../route-definition.ts";

export const adminCoworldsRoutes = {
  "admin.coworldVersions": {
    path: "/admin/coworlds/versions",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworldCertified": {
    path: "/admin/coworlds/certified",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworldImages": {
    path: "/admin/coworlds/images",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworldVersionHistory": {
    path: "/admin/coworlds/:coworldId/versions",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworldCertification": {
    path: "/admin/coworlds/:coworldId/certification",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworldActivity": {
    path: "/admin/coworlds/:coworldId/activity",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworldReference": {
    path: "/admin/coworlds/:coworldId/reference",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.coworlds": {
    path: "/admin/coworlds",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.coworld": {
    path: "/admin/coworlds/:coworldId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.replay": {
    path: "/admin/coworlds/:coworldId/replay",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.certifications": {
    path: "/admin/coworlds/certifications",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
